module.exports = __webpack_public_path__ + "img/heart2heart-poster2.df3cdb42.jpg";